module.exports = new __parcel__URL__("sprites.330033bd.jpg").toString();